import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-tem-contrato {
  background: #F5F9FB;
  padding: 40px 0;
  position: relative;
  overflow: hidden;
}

#emp-garantia-carro-tem-contrato .ctn-home-24 {
  position: relative;
  z-index: 2;
}

#emp-garantia-carro-tem-contrato .tem-contrato-textos {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#emp-garantia-carro-tem-contrato .tem-contrato-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#emp-garantia-carro-tem-contrato .tem-contrato-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-tem-contrato .tem-contrato-btn {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: 24px auto 0;
}

#emp-garantia-carro-tem-contrato .tem-contrato-img {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  mix-blend-mode: multiply;
}

@media (min-width: 992px) {
  #emp-garantia-carro-tem-contrato {
    padding: 21px 0 69px;
  }

  #emp-garantia-carro-tem-contrato .tem-contrato-textos {
    gap: 10px;
  }
  
  #emp-garantia-carro-tem-contrato .tem-contrato-titulo {
    font-size: 40px;
    line-height: 60px;
  }
  
  #emp-garantia-carro-tem-contrato .tem-contrato-texto {
    max-width: 860px;
  }
  
  #emp-garantia-carro-tem-contrato .tem-contrato-btn {
    margin: 24px 0 0;
  }
  
  #emp-garantia-carro-tem-contrato .tem-contrato-img {
    bottom: -69px;
    left: initial;
    transform: none;
    right: -100px;
  }
}`;

export default styles;